<template>
  
</template>

<script>
import axios from 'axios'
export default {
  name: 'mobileHome',
  data () {
    return {
      token: ''
    }
  },
  created () {
    if (this.$route.params.token !== 'none') {
      this.token = 'Bearer ' + this.$route.params.token
      localStorage.setItem('token', this.token)
    }
    localStorage.setItem('mobileDevice', true)
    if (localStorage.getItem('token') !== null) {
      this.handleLogin()
    } else {
      this.$router.replace({path: '/home'})
    }
  },
  methods: {
    handleLogin () {
      axios.get('/o/loginForSocialUser', null, {headers: {'Authorization': localStorage.getItem('token')}})
      .then(res => {
        this.$store.dispatch('setUserStoreData', res.data).then(res => {
          this.$router.replace({path: '/home'})
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobileHome.vue?63a9661e